const es = {
  modal: {
    eyebrow: 'Idioma',
    title: 'Selecciona tu idioma',
    subtitle: 'Elegí el idioma para ver el sitio.',
    helper: 'Español / English / Portugués'
  },
  nav: {
    home: 'Inicio',
    services: 'Servicios',
    solutions: 'Soluciones',
    stack: 'Stack',
    process: 'Proceso',
    team: 'Nuestro equipo',
    press: 'Prensa',
    contact: 'Contacto',
    menu: 'Menú',
    language: 'Idioma',
    cta: 'Agendar reunión'
  },
  hero: {
    badge: 'Desarrollo de software + Infraestructura + Automatización',
    title: 'Desarrollo de software que conecta sistemas, redes y procesos industriales.',
    description:
      'En Genius Software somos una empresa de desarrollo de software enfocada en desarrollo web, aplicaciones móviles e integración de sistemas. Trabajamos con React, Python y stacks modernos para mejorar la eficiencia operativa, la seguridad y la visibilidad en tiempo real.',
    actions: {
      primary: 'Coordinar reunión',
      secondary: 'Ver servicios',
      whatsapp: 'Contactar por WhatsApp'
    },
    metrics: [
      { value: '+20', label: 'proyectos activos' },
      { value: '99.9%', label: 'uptime en infraestructura' },
      { value: '48h', label: 'tiempo medio de entrega' }
    ],
    highlights: [
      {
        title: 'Software a medida',
        text: 'Desarrollo web y aplicaciones a tu medida.'
      },
      {
        title: 'Infraestructura TI segura',
        text: 'Redes, servidores y continuidad.'
      },
      {
        title: 'Automatización industrial',
        text: 'Control, trazabilidad y datos.'
      }
    ],
    card: {
      title: 'Soluciones integrales',
      text: 'Software, redes y automatización industrial en un solo equipo de trabajo.',
      chips: ['React', 'Python', 'DevOps', 'SCADA']
    },
    hud: {
      latencyLabel: 'Latencia',
      availabilityLabel: 'Disponibilidad',
      nodesLabel: 'Nodos'
    }
  },
  sections: {
    services: {
      eyebrow: 'Servicios',
      title: 'Soluciones de desarrollo de software, infraestructura TI y automatización industrial.',
      subtitle:
        'Diseñamos cada propuesta según tus objetivos, integrando desarrollo de software a medida, desarrollo web, infraestructura TI y automatización de procesos.'
    },
    company: {
      eyebrow: 'Nuestra empresa',
      title: 'Tecnología con enfoque en resultados.',
      subtitle:
        'Somos una empresa de desarrollo de software y consultoría tecnológica en Rosario, Argentina. Brindamos soluciones personalizadas para optimizar procesos, mejorar la eficiencia operativa y acompañar el crecimiento de empresas en un entorno digital.'
    },
    process: {
      eyebrow: 'Proceso',
      title: 'Un flujo claro para proyectos exitosos.',
      subtitle: 'Transparencia, colaboración y mejora continua en cada etapa.'
    },
    stack: {
      eyebrow: 'Stack tecnológico',
      title: 'Tecnologías modernas y escalables.',
      subtitle:
        'Combinamos desarrollo fullstack, desarrollo web, cloud e industria 4.0 para crear soluciones sólidas y listas para crecer.',
      note:
        'React, Python, APIs, bases de datos, DevOps e infraestructura TI en un mismo roadmap técnico.'
    },
    industries: {
      eyebrow: 'Sectores',
      title: 'Experiencia en múltiples industrias.',
      subtitle:
        'Nos adaptamos a cada operación para garantizar resultados alineados con tus objetivos estratégicos.'
    },
    team: {
      eyebrow: 'Confianza que crece',
      metric: '+ de 50',
      title: 'empresas confían en nuestras soluciones.',
      subtitle: 'Tecnología creada para resolver desafíos reales y acompañar a cada empresa en su crecimiento.'
    },
    teamMembers: {
      eyebrow: 'Nuestro equipo',
      title: 'Las personas detrás de cada solución.',
      subtitle:
        'Un equipo multidisciplinario de especialistas en software, infraestructura, negocios y automatización.'
    },
    contact: {
      eyebrow: 'Contacto',
      title: 'Impulsa tu negocio al siguiente nivel.',
      subtitle:
        'Coordina una reunión y hagamos crecer tu negocio con soluciones de desarrollo de software a medida.'
    }
  },
  services: [
    {
      title: 'Software a medida',
      description: 'Desarrollo de software, aplicaciones web y mobile alineadas a tu operación.',
      points: [
        'Desarrollo web y aplicaciones móviles',
        'UX/UI moderno y accesible',
        'Integraciones y APIs seguras',
        'Paneles de control y analítica'
      ],
      icon: 'software'
    },
    {
      title: 'Infraestructura y redes',
      description: 'Infraestructura TI, arquitectura, seguridad y conectividad confiable.',
      points: [
        'Diseño e implementación de redes',
        'Administración de servidores y servicios',
        'Monitoreo y soporte continuo'
      ],
      icon: 'infra'
    },
    {
      title: 'Automatización industrial',
      description: 'Industria 4.0 con procesos más eficientes y datos en tiempo real.',
      points: [
        'Integración de sensores y PLC',
        'SCADA, tableros y alertas',
        'Trazabilidad y control'
      ],
      icon: 'automation'
    },
    {
      title: 'Nube y continuidad',
      description: 'Servicios cloud y continuidad de negocio listos para escalar.',
      points: [
        'Migraciones cloud y hosting gestionado',
        'Backups, DRP y alta disponibilidad',
        'DevOps y pipelines'
      ],
      icon: 'cloud'
    }
  ],
  differentiators: [
    {
      title: 'Equipo senior',
      description: 'Profesionales en software, infraestructura y automatización.'
    },
    {
      title: 'Metodología ágil',
      description: 'Sprints cortos, visibilidad total y entregas iterativas.'
    },
    {
      title: 'Seguridad desde el inicio',
      description: 'Buenas prácticas, control de accesos y monitoreo proactivo.'
    }
  ],
  companyCard: {
    title: 'Modelo de servicio',
    description:
      'Comunicación fluida y seguimiento cercano del proyecto con foco en resultados medibles.',
    checklist: [
      'Relevamiento y diagnóstico',
      'Roadmap con entregas iterativas',
      'Documentación y capacitación',
      'Soporte y mejora continua'
    ]
  },
  companyStrip: {
    locationLabel: 'Ubicación',
    locationValue: 'Rosario, Argentina',
    contactLabel: 'Contacto',
    contactValue: '3416926584'
  },
  process: [
    {
      step: '01',
      title: 'Descubrimiento',
      description: 'Relevamos procesos, objetivos y restricciones.',
      icon: 'discover'
    },
    {
      step: '02',
      title: 'Diseño',
      description: 'Arquitectura, UX/UI y roadmap técnico.',
      icon: 'design'
    },
    {
      step: '03',
      title: 'Construcción',
      description: 'Desarrollo, infraestructura y automatización.',
      icon: 'build'
    },
    {
      step: '04',
      title: 'Evolución',
      description: 'Soporte, mejoras y nuevas integraciones.',
      icon: 'evolve'
    }
  ],
  stack: {
    items: [
      'React',
      'Python',
      'Node.js',
      'Django',
      'FastAPI',
      'PostgreSQL',
      'SQL Server',
      'Docker',
      'Kubernetes',
      'AWS',
      'Azure',
      'Grafana',
      'SCADA',
      'PLC'
    ],
    note:
      'React, Python, APIs, bases de datos, DevOps e infraestructura TI en un mismo roadmap técnico.'
  },
  industries: [
    {
      title: 'Manufactura',
      description: 'Líneas productivas, mantenimiento y trazabilidad.',
      icon: 'manufacturing'
    },
    {
      title: 'Agro y alimentos',
      description: 'Control de producción, stock y calidad.',
      icon: 'agro'
    },
    {
      title: 'Logística',
      description: 'Monitoreo, flotas y optimización de rutas.',
      icon: 'logistics'
    },
    {
      title: 'Energía',
      description: 'Telemetría, operaciones remotas y seguridad.',
      icon: 'energy'
    },
    {
      title: 'Salud',
      description: 'Integraciones, reportes y procesos críticos.',
      icon: 'health'
    },
    {
      title: 'Servicios',
      description: 'Plataformas digitales para clientes y equipos.',
      icon: 'services'
    }
  ],
  team: [
    {
      name: 'Luciano Rodas',
      role: 'Arquitecto de soluciones',
      initials: 'LR',
      photo: `${process.env.PUBLIC_URL}/equipo/lucho.png`
    },
    {
      name: 'Joel Mansilla',
      role: 'Desarrollador Backend',
      initials: 'JM',
      photo: `${process.env.PUBLIC_URL}/equipo/joel.png`
    },
    {
      name: 'Mauricio Arroyo',
      role: 'Desarrollador FullStack',
      initials: 'MA',
      photo: `${process.env.PUBLIC_URL}/equipo/mauri.png`
    },
    {
      name: 'Mauro Bertolone',
      role: 'Desarrollador FullStack',
      initials: 'MB',
      photo: `${process.env.PUBLIC_URL}/mauro.jpeg`,
      photoPosition: '50% 31%',
      photoScale: 2.6
    },
    {
      name: 'Clara Pereyra',
      role: 'Soporte Aplicaciones',
      initials: 'CP',
      photo: `${process.env.PUBLIC_URL}/clara.jpeg`,
      photoPosition: '50% 38%'
    },
    {
      name: 'Delfina Waters',
      role: 'Marketing y Comunicación',
      initials: 'DW',
      photo: `${process.env.PUBLIC_URL}/delfi.jpeg`,
      photoPosition: '50% 15%',
      photoScale: 1.5
    },
    {
      name: 'Brenda Avalos',
      role: 'Agente Comercial',
      initials: 'BA',
      photo: `${process.env.PUBLIC_URL}/brenda.jpeg`,
      photoPosition: '50% 40%',
      photoScale: 1.6
    },
    {
      name: 'Pablo Fratini',
      role: 'Team Leader',
      initials: 'PF',
      photo: `${process.env.PUBLIC_URL}/equipo/pablo.png`
    }
  ],
  press: {
    hero: {
      eyebrow: 'Prensa',
      title: 'Notas y entrevistas sobre Genius Software.',
      subtitle:
        'Una seleccion de publicaciones que cuentan como acercamos software a medida, automatizacion y digitalizacion real a la industria.',
      primaryAction: 'Ir a contacto',
      secondaryAction: 'Volver al inicio',
      featuredLabel: 'Nota destacada',
      tags: ['Desarrollo Zonal', 'Punto Biz', 'Industria 4.0']
    },
    section: {
      eyebrow: 'Cobertura',
      title: 'Medios que contaron nuestra historia.',
      subtitle: ''
    },
    cardButton: 'Ver nota',
    videoFallback: 'Tu navegador no puede reproducir este video.',
    cta: {
      eyebrow: 'Siguiente paso',
      title: 'Queres conocer lo que estamos construyendo?',
      subtitle:
        'Volve al sitio principal para ver nuestros servicios o coordina una reunion para aplicar estas soluciones en tu empresa.',
      primaryAction: 'Hablar con nosotros',
      secondaryAction: 'Ver sitio principal'
    },
    articles: [
      {
        outlet: 'Desarrollo Zonal',
        category: 'Ciencia y Tecnologia',
        date: '21 marzo 2026',
        title: 'La industria se transforma: dos emprendedores llevan la digitalizacion a las fabricas',
        description:
          'Desarrollo Zonal presento a Genius Software como una empresa regional que transforma procesos productivos con software a medida y automatizacion industrial.',
        image: `${process.env.PUBLIC_URL}/dzprensa.png`,
        imageAlt: 'Captura de la nota de Desarrollo Zonal sobre Genius Software',
        href: 'https://desarrollozonal.com/2026/03/21/la-industria-se-transforma-dos-emprendedores-llevan-la-digitalizacion-a-las-fabricas/',
        hostLabel: 'desarrollozonal.com'
      },
      {
        outlet: 'Punto Biz',
        category: 'Actualidad',
        date: '05 marzo 2026',
        title: 'De una metalurgica local a digitalizar la industria nacional',
        description:
          'Punto Biz recorrio el origen de la empresa, desde una experiencia metalurgica concreta hasta una propuesta escalable para digitalizar operaciones industriales.',
        image: `${process.env.PUBLIC_URL}/puntobizprensa.png`,
        imageAlt: 'Captura de la nota de Punto Biz sobre Genius Software',
        href: 'https://puntobiz.com.ar/actualidad/de-una-metalurgica-local-a-digitalizar-la-industria-nacional-202635600',
        hostLabel: 'puntobiz.com.ar'
      },
      {
        outlet: 'ONE VISION',
        category: 'Proyecto social',
        title: 'Proyecto social ONE VISION',
        description:
          'Una iniciativa que conecta tecnología, compromiso y comunidad para generar un impacto social positivo.',
        video: `${process.env.PUBLIC_URL}/santafe.mp4`,
        videoLabel: 'Video del proyecto social ONE VISION',
        hostLabel: 'Contenido audiovisual'
      }
    ]
  },
  contact: {
    actions: {
      email: 'Enviar email',
      call: 'Llamar ahora'
    },
    form: {
      title: 'Escribinos',
      subtitle: 'Contanos sobre tu proyecto y coordinamos una reunión.',
      nameLabel: 'Nombre',
      phoneLabel: 'Teléfono',
      emailLabel: 'Email',
      messageLabel: 'Consulta',
      namePlaceholder: 'Tu nombre',
      phonePlaceholder: 'Tu teléfono',
      emailPlaceholder: 'Tu email',
      messagePlaceholder: 'Contanos qué necesitás',
      mailSubject: 'Nueva consulta web -',
      submit: 'Enviar consulta'
    },
    widget: {
      button: 'Mensajes',
      openLabel: 'Abrir formulario de contacto',
      closeLabel: 'Cerrar formulario de contacto',
      assistant: {
        title: 'Asistente Genius',
        subtitle: 'Estoy disponible, preguntame lo que quieras.'
      }
    },
    card: {
      webLabel: 'Web',
      emailLabel: 'Email',
      phoneLabel: 'Teléfono',
      locationLabel: 'Ubicación'
    },
    values: {
      web: 'www.sistemasgenius.com',
      email: 'comercial@sistemasgenius.com',
      phone: '3416926584',
      location: 'Córdoba 836, Rosario, Santa Fe, Argentina'
    }
  },
  footer: {
    brand: 'Genius Software',
    fiscalTitle: 'Datos fiscales',
    legalLines: ['Genius Software S.A.S.', 'CUIT 30-71926918-0'],
    mapTitle: 'Ubicación de Genius Software en Córdoba 836, Rosario',
    mapsLabel: 'Ver ficha en Google Maps',
    directionsLabel: 'Cómo llegar',
    description:
      'Soluciones integrales de desarrollo de software a medida, desarrollo web, infraestructura TI y automatización industrial.',
    servicesTitle: 'Servicios',
    servicesItems: [
      'Software a medida',
      'Infraestructura y redes',
      'Automatización industrial',
      'Nube y continuidad'
    ],
    contactTitle: 'Contacto',
    contactItems: ['comercial@sistemasgenius.com', '3416926584']
  },
  whatsapp: {
    label: 'Abrir WhatsApp para consultas',
    text: 'Estamos disponibles, consultanos.'
  },
  images: {
    heroPrimaryAlt: 'Imagen principal',
    heroSecondaryAlt: 'Imagen secundaria',
    splitPrimaryAlt: 'Imagen del equipo',
    splitSecondaryAlt: 'Imagen de oficina',
    industriesPrimaryAlt: 'Imagen industria',
    industriesSecondaryAlt: 'Imagen tecnología'
  }
};

export default es;


